import { useCallback, useState } from 'react';
import apiService from '../services/api';
import { useNr2jAutoRefresh } from './useNr2jAutoRefresh';

/**
 * Compteur de demandes NR2J en attente de validation (badge menu « À valider »).
 */
export function useNr2jPendingApprovalsCount(enabled = true) {
  const [pendingCount, setPendingCount] = useState(0);

  const fetchCount = useCallback(async () => {
    if (!enabled) {
      setPendingCount(0);
      return;
    }
    try {
      const data = await apiService.getNr2jApprovalsPendingCount();
      setPendingCount(Number(data?.count) || 0);
    } catch {
      // Silencieux — badge optionnel
    }
  }, [enabled]);

  useNr2jAutoRefresh(fetchCount, { enabled, intervalMs: 12000 });

  return { pendingCount, refresh: fetchCount };
}
